import React, { FC, ReactElement, useEffect, useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import ParseHtml from '../../components/common/ParseHtml';
import withLocalization from '../../components/hoc/withLocalization';
import { clearAuthInfoFromStorage } from '../../util';
import { getHumanReadableTime } from '../../util/date';
import { OFFER_CONTACT_INFO_PATH, OFFER_ELIGIBILITY_PATH, OFFER_REVIEW_PATH } from '../../util/strings';

const SecurityTokenManager: FC<any> = (props: any): ReactElement => {
  const { localize } = props;
  const countDowntimerInterval = 300;
  const [showMessage, setshowMessage] = useState(false);
  const [showTimer, setShowTimer] = useState(false);
  const [timerDuration, setTimerDuration] = useState(countDowntimerInterval);
  const [sessionExpired, setSessionExpired] = useState(false);

  const countdownTimerOffset = 300000;
  useEffect(() => {
    const tokenExpiredAt = sessionStorage.getItem('expires_at') ?? '';
    const sessionCheckInterval = new Date(tokenExpiredAt).getTime() - new Date().getTime() - countdownTimerOffset;
    setshowMessage(false);
    setShowTimer(false);
    setTimerDuration(countDowntimerInterval);
    setSessionExpired(false);
    const interval = window.setInterval(() => {
      setshowMessage(true);
      setShowTimer(true);
      setSessionExpired(false);
    }, sessionCheckInterval);
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let timerInterval: any;

  useEffect(() => {
    if (showTimer) {
      if (timerDuration > 0) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        timerInterval = window.setInterval(() => {
          setTimerDuration(timerDuration - 1);
        }, 1000);
      } else {
        setSessionExpired(true);
        clearAuthInfoFromStorage();
        clearTimeout(timerInterval);
        setShowTimer(false);
        onExtendToken();
      }
    }
    return () => {
      clearInterval(timerInterval);
    };
  }, [showTimer, timerDuration]);

  const onExtendToken = () => {
    let currentPage = window.location.href;
    currentPage = currentPage.substr(currentPage.lastIndexOf('/')).toLocaleLowerCase();
    if (
      currentPage === OFFER_ELIGIBILITY_PATH ||
      currentPage === OFFER_CONTACT_INFO_PATH ||
      currentPage === OFFER_REVIEW_PATH
    ) {
      sessionStorage.setItem('RESET_APP_STATE', 'N');
    }
    clearAuthInfoFromStorage();
    sessionStorage.setItem('LAST_VISITED_PAGE', currentPage);
    window.location.href = '/';
  };

  return (
    <>
      {showMessage && (
        <Alert variant="warning">
          <div className="container">
            {sessionExpired ? (
              <div className="row">
                <div className="md-col-12">
                  <span className="card-title">
                    {localize('preview-sales-engine.static-content.copy.associate-search-page.security-token-expired')}
                  </span>
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="md-col-9">
                  <span className="card-title">
                    <ParseHtml
                      htmlInput={localize(
                        'preview-sales-engine.static-content.copy.associate-search-page.security-token-expiry-alert',
                        getHumanReadableTime(timerDuration),
                      )}
                    />
                  </span>
                </div>
                <div className="md-col-9">
                  <Button className="px-2 btn-link" onClick={onExtendToken}>
                    {localize('preview-sales-engine.static-content.copy.associate-search-page.click-here-to-refresh')}
                  </Button>
                </div>
              </div>
            )}
          </div>
        </Alert>
      )}
    </>
  );
};
export default React.memo(withLocalization(SecurityTokenManager));
